export default __webpack_public_path__ + "static/media/logout.6e9b6131.svg";